import React, {useEffect, useState} from 'react'
import styled from 'styled-components'
import {ToastContainer} from 'react-toastify'
import {fetchData, toasterrormsg, toastsuccessmsg, useMenuIdPermissions} from '../../../reusable'
import 'react-phone-input-2/lib/style.css'
import 'react-phone-input-2/lib/bootstrap.css'
import 'react-datepicker/dist/react-datepicker.css'
import 'react-toastify/dist/ReactToastify.css'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faPlus, faMinus} from '@fortawesome/free-solid-svg-icons'
import Select from 'react-select'
import {Tr} from '../../../_metronic/i18n/Tr'

// Container to enable horizontal scrolling for the table
const TableContainer = styled.div`
  overflow-x: auto;
  width: 100%;
`

// Styled table with nowrap cells
const StyledTable = styled.table`
  border-collapse: collapse;
  width: 100%;

  th,
  tr,
  td {
    border: 1px solid lightgray;
  }
  .inputs {
    border: 1px solid lightgray !important;
  }

  th {
    border-bottom: 1px solid lightgray;
    font-size: 1.3rem;
    text-align: center;
    padding-right: 2rem;
  }

  input {
    margin-top: 1rem;
  }
`

function BadgesPoints() {
  let t = Tr()
  const {menuIdEdit} = useMenuIdPermissions()

  const [data, setData] = useState([])

  const [taskList] = useState([
    {label: 'Like Posts', value: 'Like Posts'},
    {label: 'Follow Friends', value: 'Follow Friends'},
    {label: 'Comment on Posts', value: 'Comment on Posts'},
    {label: 'Complete Profile Details', value: 'Complete Profile Details'},
    {label: 'Publish Regular Posts', value: 'Publish Regular Posts'},
    {label: 'Publish "Featured" Posts', value: 'Publish "Featured" Posts'},
  ])

  const [recognitionList] = useState([
    {label: 'None', value: 'None'},
    {label: 'Increased Content Exposure', value: 'Increased Content Exposure'},
    {label: '2x Reward Bonus', value: '2x Reward Bonus'},
    {label: 'Social Media Promotion', value: 'Social Media Promotion'},
    {label: '3x Reward Bonus', value: '3x Reward Bonus'},
    {label: 'Special Partnership Opportunities', value: 'Special Partnership Opportunities'},
    {label: 'Ambassador', value: 'Ambassador'},
  ])

  const getBadgeSystemList = async () => {
    try {
      const response = await fetchData('admin/getbadgesdetaillist', Object, 'GET')
      if (response.status === 200) {
        const badgesData = response.data.map((badge: any) => {
          // Ensure upgradedtasks is always an array
          const upgradedtasks = badge.upgradedtasks
            ? Array.isArray(badge.upgradedtasks)
              ? badge.upgradedtasks
              : Object.entries(badge.upgradedtasks).map(([key, value]) => ({
                  title: key,
                  value,
                }))
            : [{title: '', value: ''}]
          return {
            ...badge,
            upgradedtasks,
            recognition: badge.recognition || '', // Initialize recognition
          }
        })
        setData(badgesData)
      } else {
        toasterrormsg('Failed to fetch data')
      }
    } catch (error) {
      toasterrormsg('Failed to fetch data')
    }
  }

  const removeupgradedtask = (index: number, taskIndex: number) => {
    setData((prevData: any) => {
      const newData: any = [...prevData]
      newData[index].upgradedtasks.splice(taskIndex, 1) // Remove the task at the specified index
      return newData
    })
  }
  useEffect(() => {
    getBadgeSystemList()
    document.title = 'Insayr | Badge System'
  }, [])

  const addupgradedtask = (index: number) => {
    setData((prevData: any) => {
      const newData: any = [...prevData]
      newData[index].upgradedtasks.push({title: '', value: ''})
      return newData
    })
  }

  const handleTaskChange = (badgeIndex: number, taskIndex: number, key: string, value: any) => {
    setData((prevData: any) => {
      const newData: any = [...prevData]
      if (key === 'title') {
        // If the selected task is "Complete Profile Details", clear and disable the input
        if (value === 'Complete Profile Details') {
          newData[badgeIndex].upgradedtasks[taskIndex]['value'] = '' // Clear the value
          newData[badgeIndex].upgradedtasks[taskIndex]['disabled'] = true // Set disabled to true
        } else {
          newData[badgeIndex].upgradedtasks[taskIndex]['disabled'] = false // Set disabled to false
        }
      } else if (key === 'value' && !/^\d*$/.test(value)) {
        return // Exit early if the value is not numeric
      }

      // Update the specified key with the new value
      newData[badgeIndex].upgradedtasks[taskIndex][key] = value
      return newData
    })
  }

  const handleChange = (index: number, key: string, value: any) => {
    setData((prevData: any) => {
      const newData: any = [...prevData]
      newData[index][key] = value
      return newData
    })
  }

  const validate = () => {
    // Loop through each item in the data state
    for (let i = 0; i < data.length; i++) {
      const item: any = data[i]

      // Check if the reward field is empty
      if (!item.reward.trim()) {
        toasterrormsg('Reward field cannot be empty')
        return false
      }

      // Check if the recognition field is empty (except for the first item)
      if (i !== 0 && !item.recognition.trim()) {
        toasterrormsg('Recognition field cannot be empty')
        return false
      }

      // Loop through each task in the upgradedtasks array
      for (let j = 0; j < item.upgradedtasks.length; j++) {
        const task = item.upgradedtasks[j]

        // Check if the task title or value is empty (except for the first item)
        if (i !== 0 && !task.disabled && (!task.title.trim() || !task.value.trim())) {
          toasterrormsg('Task title or value cannot be empty')
          return false
        }
        if (i !== 0 && !task.disabled && task.value === '0') {
          toasterrormsg('Task value cannot be zero')
          return false
        }
      }
    }

    // If all fields are filled, return true to allow form submission
    return true
  }
  // Submit form data
  const onSubmit = async () => {
    if (!validate()) {
      return
    }
    let adminId = ''
    const adminDataString = sessionStorage.getItem('admin')

    if (adminDataString) {
      const adminData = JSON.parse(adminDataString)
      adminId = adminData.adminId
    }

    try {
      const param = {
        adminId: adminId,
        updateBadgesDetailData: data,
      }

      const res = await fetchData('admin/updatebadgesdetaillist', param)
      if (res.status === 200) {
        toastsuccessmsg(res.message)
        getBadgeSystemList()
      } else {
        toasterrormsg(res.message)
      }
    } catch (error) {
      toasterrormsg('Failed to submit form')
    }
  }

  return (
    <>
      <ToastContainer />
      <div className='container'>
        <div className='row mt-5'>
          <TableContainer>
            <StyledTable cellPadding={19} cellSpacing={9}>
              <thead>
                <tr>
                  <th>{t('Badge Level')}</th>
                  <th>{t('Upgrade Task')}</th>
                  <th>{t('Reward')}</th>
                  <th>{t('Recognition')}</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item: any, index: any) => (
                  <tr key={item.badgesdetailId}>
                    <td data-label='Badge Level'>
                      <strong>
                        {item.degrees}-{item.badges}
                      </strong>
                    </td>
                    <td data-label='Upgrade Task'>
                      {item.upgradedtasks.map((task: any, taskIndex: any) => (
                        <React.Fragment key={taskIndex}>
                          {index === 0 ? (
                            <span
                              style={{
                                wordBreak: 'break-word',
                                display: 'flex',
                                justifyContent: 'center',
                                fontSize: '1.2rem',
                                fontWeight: 'bold',
                              }}
                            >
                              {t("New Sign Up")}
                            </span>
                          ) : (
                            <div
                              key={taskIndex}
                              className='d-flex justify-content-evenly align-items-center mt-5 '
                            >
                              <Select
                                className='me-3'
                                menuPlacement={index === 10 ? 'top' : 'auto'}
                                options={taskList}
                                value={taskList.find((t) => t.value === task.title) || null}
                                placeholder={'Select Task'}
                                onChange={(e: any) =>
                                  handleTaskChange(index, taskIndex, 'title', e.value)
                                }
                                styles={{container: (provided) => ({...provided, width: 190})}}
                              />
                              <input
                                type='text'
                                placeholder='Type'
                                value={task.value}
                                className='form-control form-control-solid w-60px h-40px mt-0 inputs'
                                disabled={
                                  task.disabled || task.title === 'Complete Profile Details'
                                } // Disable if condition is met
                                onChange={(e) =>
                                  handleTaskChange(index, taskIndex, 'value', e.target.value)
                                }
                              />
                              <div className='col-lg-3 col-xl-1 '>
                                <div className='col-2' style={{textAlign: 'right'}}>
                                  <label
                                    onClick={() => removeupgradedtask(index, taskIndex)}
                                    className='btn btn-danger'
                                  >
                                    <FontAwesomeIcon icon={faMinus} />
                                  </label>
                                </div>
                              </div>
                            </div>
                          )}
                        </React.Fragment>
                      ))}

                      {index !== 0 && (
                        <div
                          className='col-12 d-flex justify-content-end'
                          style={{marginTop: '1rem', paddingRight: '0.8rem'}}
                        >
                          <label className='btn btn-success' onClick={() => addupgradedtask(index)}>
                            <FontAwesomeIcon icon={faPlus} />
                          </label>
                        </div>
                      )}
                    </td>
                    <td data-label='Reward'>
                      <div className='d-flex justify-content-center align-items-center'>
                        <div
                          style={{
                            display: 'flex',

                            justifyContent: 'flex-start',
                            padding: '0.3rem',
                          }}
                        >
                          <span className='fw-bold'>{item.reward}</span>
                        </div>
                        <div
                          style={{
                            width: '5rem',
                            wordBreak: 'break-word',
                            display: 'flex',
                            justifyContent: 'flex-start',
                            padding: '0.3rem',
                          }}
                        >
                          <span className='fw-bold'>
                            {item.reward === '-' ? '' : 'Insayr Points*'}
                          </span>
                        </div>
                      </div>
                    </td>
                    <td data-label='Recognition'>
                      <>
                        {' '}
                        {index == 0 ? (
                          <span
                            style={{
                              wordBreak: 'break-word',
                              display: 'flex',
                              justifyContent: 'center',
                              fontSize: '1.2rem',
                              fontWeight: 'bold',
                            }}
                          >
                            {t("Badge")}
                          </span>
                        ) : (
                          <div className='d-flex justify-content-center align-items-center'>
                            <Select
                              className='me-3'
                              options={recognitionList}
                              value={
                                recognitionList.find((r) => r.value === item.recognition) || null
                              }
                              placeholder={'Select Recognition'}
                              onChange={(e: any) => {
                                handleChange(index, 'recognition', e.value)
                              }}
                              styles={{container: (provided) => ({...provided, width: 250})}}
                            />
                          </div>
                        )}
                      </>
                    </td>
                  </tr>
                ))}
              </tbody>
            </StyledTable>
          </TableContainer>
        </div>
      </div>
      <div className='d-flex align-items-center justify-content-center'>
        {menuIdEdit ? (
          <button className='btn btn-success mt-4' onClick={onSubmit}>
            {t('Submit')}
          </button>
        ) : (
          ''
        )}
      </div>
      <pre id='output' className='mt-4'></pre>
    </>
  )
}

export default BadgesPoints
